// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brarista-chat-container .chatbot-container-wrapper {
    position: fixed;
    right: 4vw;
    bottom: 1vh;
    width: 460px;
    z-index: 9999999;
}

/* Target landscape orientation on smaller screens (below 768px) */
@media only screen and (max-width: 768px) and (orientation: landscape) {
    .brarista-chat-container .chatbot-container-wrapper {
        position: fixed;
        right: 2vw;
        bottom: 2vh;
        width: 400px;
        z-index: 9999999;
    }
}

/* General small screen adjustments (mobile portrait) */
@media (max-width: 480px) {
    .brarista-chat-container .chatbot-container-wrapper {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        z-index: 9999999;
    }
}

/* Expanded chatbot container styling */
.brarista-chat-container .chatbot-container-wrapper.expanded {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -80%);
    width: 80vw;
    z-index: 9999999;
}

/* Expanded mode for landscape on small screens */
@media only screen and (max-width: 768px) and (orientation: landscape) {
    .brarista-chat-container .chatbot-container-wrapper.expanded {
        background-color: yellow;
        width: 90vw;
    }
}

/* Chatbot container styling */
.brarista-chat-container .chatbot-container {
    height: 85vh !important;
    border: 0px solid #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    border-radius: 10px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    transition: height 0.3s ease;
}

/* Adjust for landscape mobile */
@media only screen and (max-width: 768px) and (orientation: landscape) {
    .brarista-chat-container .chatbot-container {
        height: 92vh !important;
        border: 1px solid #ccc;
        border-radius: 8px;
    }
}

/* Portrait orientation on small screens */
@media only screen and (max-width: 768px) and (orientation: portrait) {
    .brarista-chat-container .chatbot-container {
        height: 92vh !important;
        border: none;
        box-shadow: none;
        border-radius: 0;
    }
}

.brarista-chat-container .chatbot-container.open {
    height: auto;
}

.brarista-chat-container .chatbot-header {
    color: #2b2c34;
    background: linear-gradient(90deg, #D9CDFA 0%, #D4E2FF 25%, #FEC4FC 50%, #D4E2FF 75%, #D9CDFA 100%);
    /* background-color: #f1f1f1; */
    padding: 10px 10px;
    height: 6vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.brarista-chat-container .chatbot-header button {
    background-color: transparent;
    color: rgb(68, 68, 68);
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
}

.brarista-chat-container .chat-messages {
    flex-grow: 1;
    overflow-y: auto;
    padding: 10px;
}

.brarista-chat-container .chat-input-container {
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;
    padding: 1px;
}

.brarista-chat-container .chat-input {
    background-color: #ffffff;
    padding: 0.5em;
    display: flex;
    align-items: center;
}

.brarista-chat-container .chat-input textarea {
    flex-grow: 1;
    padding: 0.5em 0.7em 0.2em 0.7em;
    border-bottom: 1px solid #ffffff;
    outline: none;
    resize: none;
    font-size: 0.9em;
    font-weight: 425;
    max-height: 16em;
    font-family: 'Montserrat', sans-serif;
    line-height: 'normal';
    overflow-y: scroll;
}

.brarista-chat-container .chat-input .input-with-icon {
    flex-grow: 1;
    padding: 5px 40px 5px 10px;
    border: 1px solid #fffcfc;
    border-radius: 5px;
    position: relative;
}

.brarista-chat-container .chat-input .input-with-icon+.send-button {
    position: absolute;
    right: 10px;
    background-color: transparent;
    color: #5556FB;
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 18px;
}

.brarista-chat-container .product-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
}

.brarista-chat-container .product-card img {
    max-width: 100%;
    height: auto;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

.brarista-chat-container .chatbot-toggle-button {
    position: absolute;
    right: 20px;
    bottom: 20px;
    background-color: #5556FB;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 25px 25px 25px 25px;
    font-size: 16px;
    cursor: pointer;
    transition: transform 0.3s ease;
}

.brarista-chat-container .chatbot-toggle-button button {
    background-color: transparent;
    color: white;
    border: none;
    font-size: 20px;
    cursor: pointer;
}

.brarista-chat-container .carousel-container {
    position: relative;
}

.brarista-chat-container .carousel-container:hover .react-multi-carousel-navigation-button {
    opacity: 1;
}

.brarista-chat-container .react-multi-carousel-navigation-button {
    opacity: 0;
    transition: opacity 0.3s ease;
}

.brarista-chat-container .custom-dot-list-style {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    margin-top: 10px;
}

.brarista-chat-container .custom-dot-list-style li {
    list-style: none;
    cursor: pointer;
    display: inline-block;
    margin: 0 5px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #ccc;
}

.brarista-chat-container .custom-dot-list-style li.active {
    background-color: #5556FB;
}

.brarista-chat-container .carousel-item-padding-40-px {
    padding: 0 40px;
}

.brarista-chat-container .quick-view-button {
    cursor: 'pointer';
    width: '142px';
    height: '30px';
    padding: '0px 8px';
    border: '1px solid #572663';
    box-sizing: 'border-box';
    border-radius: '25px';
    background-color: '#ffffff';
    color: '#572663';
    font-size: '14px';
    font-weight: 500;
    line-height: '18px';
    outline: 'none';
}

.brarista-chat-container .chatbot-footer {
    background-color: #f1f1f1;
    padding: 2px 0 0px 0;
    text-align: center;
    font-size: 14px;
    color: #666;
}

.brarista-chat-container .product-card {
    font-size: 16px;
    font-weight: 500;
    margin: 5px 3px 5px 3px;
    border: 0.5px solid #eee;
    border-radius: 2%;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);
}

.brarista-chat-container .bouncing-loader {
    display: flex;
    justify-content: left;
}

.brarista-chat-container .bouncing-loader>div {
    width: 1vh;
    height: 1vh;
    margin: 3px 6px;
    border-radius: 50%;
    background-color: #a3a1a1;
    opacity: 1;
    animation: bouncing-loader 0.6s infinite alternate;
}

@keyframes bouncing-loader {
    to {
        opacity: 0.1;
        transform: translateY(-0.5vh);
    }
}

.brarista-chat-container .bouncing-loader>div:nth-child(2) {
    animation-delay: 0.2s;
}

.brarista-chat-container .bouncing-loader>div:nth-child(3) {
    animation-delay: 0.4s;
}

.brarista-chat-container .modal-image-container {
    width: 80%;
    margin: 0;
    overflow: hidden;
    border-radius: 0.75em;
}

.brarista-chat-container .modal-image {
    width: 100%;
}

.brarista-chat-container .markdown-content a {
    color: blue;
    text-decoration: underline;
}

.brarista-chat-container .dislike-reason-container {
    width: 95%;
    border: 0px solid #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    padding: 0.1em 0 0.5em 0;
    overflow: hidden;
    border-radius: 0.65em;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    transition: height 0.3s ease;
    display: none;
}

.brarista-chat-container .dislike-reason-header {
    color: #2b2c34;
    padding: 0.3em 1em;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.brarista-chat-container .dislike-reason-title {
    font-size: 1em;
    font-weight: 500;
}

.brarista-chat-container .dislike-reason-body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 1em;
}

.brarista-chat-container .dislike-reason-prompt {
    cursor: pointer;
    background-color: #dfb7f0;
    padding: 0.25em 1em;
    border-radius: 1.2em;
    max-width: 90%;
    word-break: break-word;
    font-size: 0.9em;
    color: #572663;
    margin: 0.25em;
    margin-bottom: 0.5em;
    line-height: 1.5;
    white-space: pre-wrap;
    font-weight: 400;
    padding: 0.5em;
}

.brarista-chat-container .chat-icon {
    width: 6vh;
    height: 6vh;
    background-color: transparent;
}

.brarista-chat-container ol,ul{
    padding-left: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat/chat.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA,kEAAkE;AAClE;IACI;QACI,eAAe;QACf,UAAU;QACV,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA,uDAAuD;AACvD;IACI;QACI,eAAe;QACf,OAAO;QACP,SAAS;QACT,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA,uCAAuC;AACvC;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,gBAAgB;AACpB;;AAEA,iDAAiD;AACjD;IACI;QACI,wBAAwB;QACxB,WAAW;IACf;AACJ;;AAEA,8BAA8B;AAC9B;IACI,uBAAuB;IACvB,yBAAyB;IACzB,wCAAwC;IACxC,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA,gCAAgC;AAChC;IACI;QACI,uBAAuB;QACvB,sBAAsB;QACtB,kBAAkB;IACtB;AACJ;;AAEA,0CAA0C;AAC1C;IACI;QACI,uBAAuB;QACvB,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mGAAmG;IACnG,+BAA+B;IAC/B,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;IACrC,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,eAAe;IACf,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;IACxB,qBAAqB;IACrB,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,wBAAwB;IACxB,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,kDAAkD;AACtD;;AAEA;IACI;QACI,YAAY;QACZ,6BAA6B;IACjC;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,0CAA0C;IAC1C,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".brarista-chat-container .chatbot-container-wrapper {\n    position: fixed;\n    right: 4vw;\n    bottom: 1vh;\n    width: 460px;\n    z-index: 9999999;\n}\n\n/* Target landscape orientation on smaller screens (below 768px) */\n@media only screen and (max-width: 768px) and (orientation: landscape) {\n    .brarista-chat-container .chatbot-container-wrapper {\n        position: fixed;\n        right: 2vw;\n        bottom: 2vh;\n        width: 400px;\n        z-index: 9999999;\n    }\n}\n\n/* General small screen adjustments (mobile portrait) */\n@media (max-width: 480px) {\n    .brarista-chat-container .chatbot-container-wrapper {\n        position: fixed;\n        left: 0;\n        bottom: 0;\n        width: 100%;\n        z-index: 9999999;\n    }\n}\n\n/* Expanded chatbot container styling */\n.brarista-chat-container .chatbot-container-wrapper.expanded {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -80%);\n    width: 80vw;\n    z-index: 9999999;\n}\n\n/* Expanded mode for landscape on small screens */\n@media only screen and (max-width: 768px) and (orientation: landscape) {\n    .brarista-chat-container .chatbot-container-wrapper.expanded {\n        background-color: yellow;\n        width: 90vw;\n    }\n}\n\n/* Chatbot container styling */\n.brarista-chat-container .chatbot-container {\n    height: 85vh !important;\n    border: 0px solid #ffffff;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n    border-radius: 10px;\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    transition: height 0.3s ease;\n}\n\n/* Adjust for landscape mobile */\n@media only screen and (max-width: 768px) and (orientation: landscape) {\n    .brarista-chat-container .chatbot-container {\n        height: 92vh !important;\n        border: 1px solid #ccc;\n        border-radius: 8px;\n    }\n}\n\n/* Portrait orientation on small screens */\n@media only screen and (max-width: 768px) and (orientation: portrait) {\n    .brarista-chat-container .chatbot-container {\n        height: 92vh !important;\n        border: none;\n        box-shadow: none;\n        border-radius: 0;\n    }\n}\n\n.brarista-chat-container .chatbot-container.open {\n    height: auto;\n}\n\n.brarista-chat-container .chatbot-header {\n    color: #2b2c34;\n    background: linear-gradient(90deg, #D9CDFA 0%, #D4E2FF 25%, #FEC4FC 50%, #D4E2FF 75%, #D9CDFA 100%);\n    /* background-color: #f1f1f1; */\n    padding: 10px 10px;\n    height: 6vh;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.brarista-chat-container .chatbot-header button {\n    background-color: transparent;\n    color: rgb(68, 68, 68);\n    border: none;\n    padding: 5px 10px;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.brarista-chat-container .chat-messages {\n    flex-grow: 1;\n    overflow-y: auto;\n    padding: 10px;\n}\n\n.brarista-chat-container .chat-input-container {\n    display: flex;\n    flex-direction: column;\n    background-color: #f1f1f1;\n    padding: 1px;\n}\n\n.brarista-chat-container .chat-input {\n    background-color: #ffffff;\n    padding: 0.5em;\n    display: flex;\n    align-items: center;\n}\n\n.brarista-chat-container .chat-input textarea {\n    flex-grow: 1;\n    padding: 0.5em 0.7em 0.2em 0.7em;\n    border-bottom: 1px solid #ffffff;\n    outline: none;\n    resize: none;\n    font-size: 0.9em;\n    font-weight: 425;\n    max-height: 16em;\n    font-family: 'Montserrat', sans-serif;\n    line-height: 'normal';\n    overflow-y: scroll;\n}\n\n.brarista-chat-container .chat-input .input-with-icon {\n    flex-grow: 1;\n    padding: 5px 40px 5px 10px;\n    border: 1px solid #fffcfc;\n    border-radius: 5px;\n    position: relative;\n}\n\n.brarista-chat-container .chat-input .input-with-icon+.send-button {\n    position: absolute;\n    right: 10px;\n    background-color: transparent;\n    color: #5556FB;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 18px;\n}\n\n.brarista-chat-container .product-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 10px;\n}\n\n.brarista-chat-container .product-card img {\n    max-width: 100%;\n    height: auto;\n    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.brarista-chat-container .chatbot-toggle-button {\n    position: absolute;\n    right: 20px;\n    bottom: 20px;\n    background-color: #5556FB;\n    color: white;\n    border: none;\n    padding: 10px 15px;\n    border-radius: 25px 25px 25px 25px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: transform 0.3s ease;\n}\n\n.brarista-chat-container .chatbot-toggle-button button {\n    background-color: transparent;\n    color: white;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.brarista-chat-container .carousel-container {\n    position: relative;\n}\n\n.brarista-chat-container .carousel-container:hover .react-multi-carousel-navigation-button {\n    opacity: 1;\n}\n\n.brarista-chat-container .react-multi-carousel-navigation-button {\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.brarista-chat-container .custom-dot-list-style {\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    justify-content: center;\n    margin-top: 10px;\n}\n\n.brarista-chat-container .custom-dot-list-style li {\n    list-style: none;\n    cursor: pointer;\n    display: inline-block;\n    margin: 0 5px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: #ccc;\n}\n\n.brarista-chat-container .custom-dot-list-style li.active {\n    background-color: #5556FB;\n}\n\n.brarista-chat-container .carousel-item-padding-40-px {\n    padding: 0 40px;\n}\n\n.brarista-chat-container .quick-view-button {\n    cursor: 'pointer';\n    width: '142px';\n    height: '30px';\n    padding: '0px 8px';\n    border: '1px solid #572663';\n    box-sizing: 'border-box';\n    border-radius: '25px';\n    background-color: '#ffffff';\n    color: '#572663';\n    font-size: '14px';\n    font-weight: 500;\n    line-height: '18px';\n    outline: 'none';\n}\n\n.brarista-chat-container .chatbot-footer {\n    background-color: #f1f1f1;\n    padding: 2px 0 0px 0;\n    text-align: center;\n    font-size: 14px;\n    color: #666;\n}\n\n.brarista-chat-container .product-card {\n    font-size: 16px;\n    font-weight: 500;\n    margin: 5px 3px 5px 3px;\n    border: 0.5px solid #eee;\n    border-radius: 2%;\n    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.brarista-chat-container .bouncing-loader {\n    display: flex;\n    justify-content: left;\n}\n\n.brarista-chat-container .bouncing-loader>div {\n    width: 1vh;\n    height: 1vh;\n    margin: 3px 6px;\n    border-radius: 50%;\n    background-color: #a3a1a1;\n    opacity: 1;\n    animation: bouncing-loader 0.6s infinite alternate;\n}\n\n@keyframes bouncing-loader {\n    to {\n        opacity: 0.1;\n        transform: translateY(-0.5vh);\n    }\n}\n\n.brarista-chat-container .bouncing-loader>div:nth-child(2) {\n    animation-delay: 0.2s;\n}\n\n.brarista-chat-container .bouncing-loader>div:nth-child(3) {\n    animation-delay: 0.4s;\n}\n\n.brarista-chat-container .modal-image-container {\n    width: 80%;\n    margin: 0;\n    overflow: hidden;\n    border-radius: 0.75em;\n}\n\n.brarista-chat-container .modal-image {\n    width: 100%;\n}\n\n.brarista-chat-container .markdown-content a {\n    color: blue;\n    text-decoration: underline;\n}\n\n.brarista-chat-container .dislike-reason-container {\n    width: 95%;\n    border: 0px solid #ffffff;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    padding: 0.1em 0 0.5em 0;\n    overflow: hidden;\n    border-radius: 0.65em;\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    transition: height 0.3s ease;\n    display: none;\n}\n\n.brarista-chat-container .dislike-reason-header {\n    color: #2b2c34;\n    padding: 0.3em 1em;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.brarista-chat-container .dislike-reason-title {\n    font-size: 1em;\n    font-weight: 500;\n}\n\n.brarista-chat-container .dislike-reason-body {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    margin: 0 1em;\n}\n\n.brarista-chat-container .dislike-reason-prompt {\n    cursor: pointer;\n    background-color: #dfb7f0;\n    padding: 0.25em 1em;\n    border-radius: 1.2em;\n    max-width: 90%;\n    word-break: break-word;\n    font-size: 0.9em;\n    color: #572663;\n    margin: 0.25em;\n    margin-bottom: 0.5em;\n    line-height: 1.5;\n    white-space: pre-wrap;\n    font-weight: 400;\n    padding: 0.5em;\n}\n\n.brarista-chat-container .chat-icon {\n    width: 6vh;\n    height: 6vh;\n    background-color: transparent;\n}\n\n.brarista-chat-container ol,ul{\n    padding-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
